export type LoginTypeValue = 'requireLogin' | 'hideLogin';

export const LoginTypeEnum = {
  requireLogin: 'requireLogin',
  hideLogin: 'hideLogin',
};
